import { Component } from "vue-property-decorator";
import BaseBlock from "@/blocks/base-block";
import { Block } from '../../../helpers/components';
import { UniversalFormMailRequestDTO } from '../../../model/UniversalFormMailRequestDTO';
import { htmlEncode } from '../../../helpers/html'
import { getRecaptchaToken } from '../../../helpers/recaptcha'

import Bowser from 'bowser';

@Block() @Component
export class UniversalForm extends BaseBlock {
	//sending: boolean = false;
	//success: boolean = false;
	//failure: boolean = false;

	gdprInformation: string = null;

	successElement: HTMLFormElement = null;
	sendingElement: HTMLFormElement = null;
	failureElement: HTMLFormElement = null;

	mounted() {
		this.successElement = document.getElementById(this.getText('form-success')) as HTMLFormElement;
		this.sendingElement = document.getElementById(this.getText('form-sending')) as HTMLFormElement;
		this.failureElement = document.getElementById(this.getText('form-failure')) as HTMLFormElement;

		this.successElement.setAttribute('hidden', '');
		this.sendingElement.setAttribute('hidden', '');
		this.failureElement.setAttribute('hidden', '');
	}

	

	async submit() {
		const form = this.$refs.form as HTMLFormElement;

		const formData = new FormData(form);

		const mailFormItems = this.getText('mail-form-items').split(';');

		const gdprFormItemName = this.getText('form-gdpr-item-name');
		const gdprFormItemValue = formData.get(gdprFormItemName);

		let messageFormData = mailFormItems.map(inputName => {
			const input = form[inputName] as HTMLElement;
			const label = input.getAttribute('data-mail-label') || inputName;

			if (label === gdprFormItemName && gdprFormItemValue === "on") {
				const bowser = Bowser.parse(window.navigator.userAgent)
				this.gdprInformation = "" + this.$store.timeId + "," + this.$store.langId + "," + bowser.browser.name.toString() + "," + bowser.browser.version.toString() + "," + bowser.os.name.toString() + "," + bowser.os.version.toString() + "";


				return '- Klient souhlasí se zpracováním osobních údajů'
			}

			return `- ${label}: ${htmlEncode(String(formData.get(inputName) || ''))} <br>`;
		}).join('\n\r');

		const clientMailItemName = this.getText('form-client-mail-item');

		const mailRequest: UniversalFormMailRequestDTO = {
			mailTo: this.getText('mail-to'),
			mailToClient: clientMailItemName && formData.get(clientMailItemName) as string,
			message: this.getText('mail-template', [messageFormData]),
			messageToClient: this.getText('mail-client-template', [messageFormData]),
			recaptchaResponse: null,
			senderName: this.getText('sender-name'),
			senderEmail: this.getText('sender-email'),
			gdprInformation: this.gdprInformation,
			subject: this.getText('subject')
		};

		try {
			//this.sending = true;
			this.sendingElement.removeAttribute('hidden');

			mailRequest.recaptchaResponse = await getRecaptchaToken('universal_form')
			await this.$mailService.sendUniversalFormMail(mailRequest);

			this.successElement.removeAttribute('hidden');
			this.sendingElement.setAttribute('hidden', '');
			this.failureElement.setAttribute('hidden', '');

			form.reset();


			//this.sending = false;
			//this.success = true;
			//this.failure = false;
		} catch (e) {
			this.successElement.setAttribute('hidden', '');
			this.sendingElement.setAttribute('hidden', '');
			this.failureElement.removeAttribute('hidden');

			//this.sending = false;
			//this.success = false;
			//this.failure = true;
		}
	}

}

export default UniversalForm;
